import { Rect } from '../../Rect';
import { DEFAULT_MARGIN } from './consts';
import { ChartDimensions, Margin } from './types';

export const getDimensions = (
  clientRect: Pick<Rect, 'width' | 'height'>,
  margin: Margin = DEFAULT_MARGIN
): ChartDimensions => {
  const containerWidth = Math.floor(clientRect.width);
  const containerHeight = Math.floor(clientRect.height);

  const chartWidth = containerWidth - margin.left - margin.right;
  const chartHeight = containerHeight - margin.bottom - margin.top;
  return {
    margin,
    container: {
      width: containerWidth,
      height: containerHeight,
    },
    chart: {
      width: chartWidth,
      height: chartHeight,
    },
  };
};
